export default {"src":"/_next/static/media/down-arrow.058783e1.svg","height":9,"width":16};